import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class TagsDomainService {
  constructor(private commonService: CommonService) {}

  getAllTags(requestBody: any) {
    return this.commonService.API_POST(EndPoints.GetAllTags, requestBody, false);
  }

  getTagsDropdownList(siteId: any) {
    return this.commonService.API_GET(EndPoints.GetTagsDropdownlist + `?siteId=${siteId}`, false);
  }

  addTagGroup(tagGroupData: any) {
    return this.commonService.API_POST(EndPoints.AddTagGroup, tagGroupData, false);
  }

  updateTagGroup(tagGroupData: any) {
    return this.commonService.API_POST(EndPoints.UpdateTagGroup, tagGroupData, false);
  }

  deleteTagGroup(groupId: any) {
    return this.commonService.API_DELETE(EndPoints.DeleteTagGroup + `/${groupId}`);
  }

  addTag(tagData: any) {
    return this.commonService.API_POST(EndPoints.AddTag, tagData, false);
  }

  updateTag(tagData: any) {
    return this.commonService.API_POST(EndPoints.UpdateTag, tagData, false);
  }

  deleteTag(groupId: any, tagId: any) {
    return this.commonService.API_DELETE(EndPoints.DeleteTag + `/${groupId}/${tagId}`);
  }

  getTagGroupNameList(siteId: any) {
    return this.commonService.API_GET(EndPoints.GetTagGroupName + `?siteId=${siteId}`, false);
  }

  getUserProfileData() {
    return this.commonService.API_GET(EndPoints.GetPaybevUserDetails, false);
  }

  updateProfileData(profileData: any) {
    return this.commonService.API_POST(EndPoints.UpdateProfileData, profileData, false);
  }
}
